import { render, staticRenderFns } from "./AccidentRank.vue?vue&type=template&id=ac5e4fb4&scoped=true&"
import script from "./AccidentRank.vue?vue&type=script&lang=js&"
export * from "./AccidentRank.vue?vue&type=script&lang=js&"
import style0 from "./AccidentRank.vue?vue&type=style&index=0&id=ac5e4fb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5e4fb4",
  null
  
)

export default component.exports